// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"1396":"average-head","8201":"MirrorAsyncRoot","8705":"MirrorContainer"}[chunkId] || chunkId) + ".chunk.js";
};